export function formatDateRelativeTime(date: string | Date) {
  if (typeof date === 'string') {
    date = new Date(date)
  }
  const now = new Date()

  const diffInMs = now.getTime() - date.getTime()
  const diffInSeconds = Math.floor(diffInMs / 1000)
  const diffInMinutes = Math.floor(diffInSeconds / 60)
  const diffInHours = Math.floor(diffInMinutes / 60)
  const diffInDays = Math.floor(diffInHours / 24)

  const rtf = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'always' })

  let relativeTime: string

  if (diffInDays >= 1) {
    relativeTime = rtf.format(-diffInDays, 'day')
  } else if (diffInHours >= 1) {
    relativeTime = rtf.format(-diffInHours, 'hour')
  } else if (diffInMinutes >= 1) {
    relativeTime = rtf.format(-diffInMinutes, 'minute')
  } else {
    relativeTime = rtf.format(-diffInSeconds, 'second')
  }

  const timeFormatter = new Intl.DateTimeFormat('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  })

  const formattedTime = timeFormatter.format(date)

  return `${relativeTime} às ${formattedTime}h`
}
